export default {
  book: "",
  categories: [],
  user: "",
  error: false,
  errorMessage: '',
}